<template>
  <div>
    <TheModal />
    <div
      v-if="!regroupementsEditMode"
      class="regroupements__wrapper"
    >
      <h1>
        Gestion des regroupements par variantes
      </h1>
      <div class="regroupements">
        <div v-if="Object.keys(regroupements).length">
          <ul class="regroupements__list">
            <li
              v-for="(regroupement, id) of regroupements"
              :key="id"
              class="regroupements__list__item"
              @click="toggleEditMode(id)"
            >
              {{ regroupement.titre }}
            </li>
          </ul>
          <Pagination
            v-if="regroupementsPages > 1"
            :current="regroupementsCurrent"
            :pages="regroupementsPages"
            @change="setRegroupementsPage"
          />
        </div>
        <span
          v-else
          class="empty"
        >
          Aucune variante
        </span>
      </div>
      <p>
        <button @click="toggleEditMode()">
          Nouveau regroupement
        </button>
      </p>
    </div>
    <div v-else>
      <h1>
        Edition d'un regroupement par variantes
      </h1>
      <TheRegroupementsEdit
        :type-regroupement="typeRegroupement"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TheRegroupementsEdit from './TheRegroupementsEdit.vue'
import TheModal from './modal/TheModal.vue'
import Pagination from './Pagination.vue'
export default {
  components: { TheRegroupementsEdit, TheModal, Pagination },
  props: {
    typeRegroupement: {
      type: String,
      default: '0'
    }
  },
  computed: {
    ...mapGetters([
      'regroupements',
      'regroupementsPages',
      'regroupementsCurrent',
      'regroupementsEditMode'
    ])
  },
  beforeMount() {
    this.getRegroupements()
  },
  methods: {
    ...mapActions([
      'getRegroupements',
      'setCurrentRegroupement',
      'setRegroupementAttributs',
      'setRegroupementsPage',
      'toggleRegroupementEditMode'
    ]),
    toggleEditMode(id = null) {
      this.toggleRegroupementEditMode()
      if (id !== null) this.bootstrapRegroupement(id)
    },
    bootstrapRegroupement(id) {
      this.setCurrentRegroupement(id)
      this.setRegroupementAttributs()
    }
  }
}
</script>

<style scoped>
.regroupements {
  display: flex;
  flex-direction: column;
}

.regroupements__list {
  cursor: default;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  list-style-type: none;
  min-height: 18rem;
}

.regroupements__list__item {
  padding: 7px 12px;
  cursor: pointer;
  border-bottom: 1px solid #e6e4df;
}
.regroupements__list__item:hover {
  background: #f7fcff;
}
.empty {
  color: #616161;
}
</style>
